﻿'use strict';

/**
 * @ngdoc directive
 * @name ntmApp.directive:cluetip
 * @description
 * # cluetip
 */
angular.module('ntmApp')
  .directive('cluetip', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/cluetip.html',
          scope: {
              data: '=',
              customClass: '=',
              icon: '=',
              position: '=?',
          },
          link: function (scope) {
              if (scope.data) {
                  scope.timeout = scope.data.type === 'Quick' ? 0 : 100000;
                  scope.theme = scope.data.type === 'Quick' ? 'ns-popover-tooltip-theme ns-popover-eSirius-theme' : 'ns-popover-tooltip-theme';
                  scope.position = scope.position || 'bottom|left';
              }
          }
      };
  });